import { isGlimra, isJuhlapesu } from './environmentUtils';

const COUNTRIES = {
  SWEDEN: 'se',
  FINLAND: 'fi',
};

const getCountry = () => {
  if (isGlimra) return COUNTRIES.SWEDEN;
  if (isJuhlapesu) return COUNTRIES.FINLAND;
};

export default getCountry();
